module.exports = "<div ng-if=!vm.loading ag-grid=vm.agGridOptions class=\"gz-grid ag-material\"></div>";


//////////////////
// WEBPACK FOOTER
// ../~/@printos/gazelle/src/extensions/grid/grid.jade
// module id = 258
// module chunks = 0